import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="/images/logo.jpg" 
              alt="Réseau d'Aide à Domicile" 
              className="footer-logo"
            />
            <p className="footer-tagline">Votre Partenaire de Confiance pour l'Aide à Domicile</p>
            <p className="footer-text">Lyon et environs depuis 2015</p>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h3 className="footer-title">Nos Services</h3>
            <ul className="footer-links">
              <li><Link to="/aides-personne">Aides à la personne</Link></li>
              <li><Link to="/garde-enfant">Garde d'enfant</Link></li>
              <li><Link to="/menage">Ménage et repassage</Link></li>
              <li><Link to="/bricolage">Bricolage et jardinage</Link></li>
              <li><Link to="/informatique">Informatique</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone size={18} />
                <a href="tel:0481119591">04 81 11 95 91</a>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <a href="mailto:serviceconsommateur@reseaudaideadomicile.fr">serviceconsommateur@reseaudaideadomicile.fr</a>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>23 rue du Dauphiné, 69003 Lyon</span>
              </div>
            </div>
          </div>

          {/* Horaires */}
          <div className="footer-section">
            <h3 className="footer-title">Horaires</h3>
            <div className="footer-hours">
              <p>Lundi – Vendredi : 09h00 – 18h00</p>
              <p>Samedi : Fermé</p>
              <p>Dimanche : Fermé</p>
            </div>
            
            <div className="footer-social-section">
              <h4 className="footer-social-title">Suivez-nous</h4>
              <div className="footer-social">
                <a 
                  href="https://www.facebook.com/reseaudaideadomicile/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="social-link facebook"
                  aria-label="Facebook"
                >
                  <Facebook size={28} />
                  <span>Facebook</span>
                </a>
                <a 
                  href="https://www.instagram.com/reseaudaideadomicile/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="social-link instagram"
                  aria-label="Instagram"
                >
                  <Instagram size={28} />
                  <span>Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2015-2025 Réseau d'Aide à Domicile. Tous droits réservés.</p>
          <div className="footer-legal">
            <Link to="/confidentialite">Politique de confidentialité</Link>
            <span>•</span>
            <Link to="/mentions-legales">Mentions légales</Link>
            <span>•</span>
            <a 
              href="https://webysee.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              Créé par webysee.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};